import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


//IMPORT OTHER MODULES

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MainJobModule } from '../../jobs/main-job/main-job.module';
import { MainClientRoutingModule } from './main-client-routing.module';


// IMPORT SERVICE
import { MapsService } from '../../services/maps.service';
import { UtilityService } from '../../services/utility.service';

// IMPORT CLIENT COMPONENTS
import { MainClientComponent } from './main-client.component';
import { ClientsComponent } from './../clients.component';
import { AddClientModalComponent } from '../add-client-modal/add-client-modal.component';
import { EditClientModalComponent } from '../edit-client-modal/edit-client-modal.component';
import { SingleClientComponent } from '../single-client/single-client.component';
import { AddLocationComponent } from '../single-client/add-location/add-location.component';
import { ClientDashboardComponent } from '../client-dashboard/client-dashboard.component';
import { AllotmentConfirmationComponent } from '../../courses/assignment-status/allotment-confirmation/allotment-confirmation.component';
// import { AssignmentStatusComponent } from '../../courses/assignment-status/assignment-status.component';
import { AssignmentRowComponent } from '../../courses/assignment-row/assignment-row.component';
import { AssignmentResourceComponent } from '../../courses/assignment-resource/assignment-resource.component';
import { MainAttendanceModule } from 'src/app/attendance/main-attendance/main-attendance.module';
import { LabourJobModule } from 'src/app/labour-job/labour-job/labour-job.module';
import { MainFolderModuleModule } from 'src/app/folder/main-folder-module/main-folder.module';



@NgModule({
  declarations: [
    MainClientComponent,
    ClientsComponent,
    AddClientModalComponent,
    EditClientModalComponent,
    SingleClientComponent,
    AddLocationComponent,
    ClientDashboardComponent,
    // AssignmentStatusComponent,
    // AssignmentRowComponent,
    // AssignmentResourceComponent,
    // AllotmentConfirmationComponent
  ],
  imports: [
    MainClientRoutingModule,
    CommonModule,
    SharedModule,
    MaterialsModule,
    LabourJobModule,
    MainJobModule,
    MainFolderModuleModule,
    MainAttendanceModule
  ],
  exports: [
    // ClientsComponent,
    // AssignmentStatusComponent,
    // AssignmentRowComponent,
    // AssignmentResourceComponent,
    ClientDashboardComponent,
  ],
  entryComponents: [
    AddClientModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    MapsService,
    UtilityService,
    // MainJobModule
  ]
})
export class MainClientModule { }
